module.exports = __webpack_public_path__ + "static/media/bookingfileSlashView.cf469da2.svg";